import { createContext, splitProps, useContext } from 'solid-js';
import { ToastRegion } from '../overlays/toast';
import type { ParentProps } from 'solid-js';

type CTX = { baseUrl: string; onDialogClosed?: (key: string) => void; onDialogOpened?: (key: string) => void };
type Props = ParentProps<CTX>;

export function UIProvider(props: Props) {
	const [, rest] = splitProps(props, ['children']);
	if (!props.baseUrl.startsWith('http')) {
		throw new Error('Invalid host – missing protocol');
	}
	return (
		<UIContext.Provider value={rest}>
			{props.children}
			<ToastRegion />
		</UIContext.Provider>
	);
}

const UIContext = createContext<CTX>({ baseUrl: 'https://localhost' });

export function useUIContext() {
	return useContext(UIContext);
}
